/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountRetrieveAIApiKey = zod.strictObject({
    anthropic_api_key: zod.string().nullable(),
});

export type AccountRetrieveAIApiKey = zod.input<typeof AccountRetrieveAIApiKey>;
export type AccountRetrieveAIApiKeyOutput = zod.output<
    typeof AccountRetrieveAIApiKey
>;
